import React from 'react';

const CHUNK_RELOAD_KEY = 'schoolbench-route-chunk-reload';

const isChunkLoadError = (error) => {
  const message = `${error?.name || ''} ${error?.message || ''}`;

  return /ChunkLoadError|Loading chunk \d+ failed|Loading CSS chunk \d+ failed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message);
};

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isReloading: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Route rendering failed:', error, errorInfo);

    if (!isChunkLoadError(error) || typeof window === 'undefined') {
      return;
    }

    const reloadKey = `${window.location.pathname}${window.location.search}`;

    try {
      if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === reloadKey) {
        return;
      }

      window.sessionStorage.setItem(CHUNK_RELOAD_KEY, reloadKey);
    } catch (storageError) {
      console.warn('Unable to record route chunk reload state:', storageError);
    }

    this.setState({ isReloading: true }, () => {
      window.location.reload();
    });
  }

  render() {
    const { error, isReloading } = this.state;

    if (!error) {
      return this.props.children;
    }

    if (isReloading) {
      return (
        <div className="loading-suspense">
          <span className="dot-pulse"></span>
        </div>
      );
    }

    return (
      <div className="loading-suspense">
        <div className="text-center">
          <p className="mb-3">This page could not be loaded.</p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default RouteErrorBoundary;
